module.exports = __webpack_public_path__ + "static/media/list_icon.156e6dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list_icon.svg
// module id = 108
// module chunks = 0